module.exports = __webpack_public_path__ + "static/media/liveChat.d8d435aa.mp3";